export default {
  env: "prod",
  appCode: "AC",
  serverUrl: "https://web.advicecoachserver.com",
  mobileServerUrl: "https://mobile.advicecoachserver.com",
  commServerUrl: "https://comm.advicecoachserver.com",
  mixpanel: {
    token: "aa2b857803bbd5c81b412f26582b6ee1",
  },
  auth0: {
    domain: "advicecoach.auth0.com",
    clientID: "XYUfgxnGgzGVO4ENh8q1YLwXbFAYJ0ND",
  },
  cloudinary: {
    cloudName: "advicecoach",
    apiKey: "587244823128573",
    apiSecret: "HuSrrEY1WLTIzNqnuutLgKrYNG4",
  },
  s3: {
    bucket: "user-image-storage",
    region: "us-west-2",
    s3Url: "https://user-image-storage.s3.amazonaws.com",
  },
  system: {
    mobileScreenWidthThreshold: 500,
    freeTrailDays: 60,
  },
  publishableStripeKey:
    "pk_live_51C5FhAEpDhzqppArOHlv5hZgeHYQvFQt11W1F5Nx81udUe4z5VdOODvOrvysIiBYF5Iikbabuh9dNRSoFVn5ayoT0097mDGcB0",
};



// WEBPACK FOOTER //
// ./src/config.js